import { useElements, useStripe } from '@stripe/react-stripe-js'
import { FORM_ERROR } from 'final-form'
import { useCardSetupIntent, useLogStripeError } from '@mwxltd/flix-api-client'
import bugsnag from '../../services/bugsnag'

export const useStripeCardSetupSubmission = ({ onSubmit }) => {
  const stripe = useStripe()
  const elements = useElements()
  const { fetchSetupIntent } = useCardSetupIntent()
  const { logStripeError } = useLogStripeError(bugsnag.notify)

  const handleCardSubmit = async ({ name }) => {
    try {
      const { clientSecret } = await fetchSetupIntent()
      const { setupIntent, error } = await stripe.confirmCardSetup(clientSecret, {
        payment_method: {
          card: elements.getElement('card'),
          billing_details: { name },
        },
      })

      if (error) {
        logStripeError(error)
        return { [FORM_ERROR]: error.message }
      }

      const resultOrErrors = await onSubmit({
        name,
        paymentMethodId: setupIntent.payment_method,
      })

      if (!resultOrErrors.data) {
        return resultOrErrors // Contains formatted final-form errors
      }

      // 3DSecure might require additional actions
      const status = resultOrErrors.data.startSubscription || {}
      if (status.requiresAction) {
        const { paymentIntent, error } = await stripe.confirmCardPayment(status.clientSecret)

        if (error) {
          logStripeError(error)
          return { [FORM_ERROR]: error.message }
        }

        const resultOrErrors = await onSubmit({
          paymentIntentId: paymentIntent.id,
          confirmation: true,
        })

        if (!resultOrErrors.data) {
          return resultOrErrors // Contains formatted final-form errors
        }
      }
    } catch (error) {
      bugsnag.notify(error, (event) => {
        event.addMetadata('details', { name })
      })
      return { [FORM_ERROR]: error.message }
    }
  }

  return { handleCardSubmit }
}
